/**
 * @fileoverview Abort signal handling for CAVE operations.
 *
 * Provides utilities for checking and enforcing abort signals across
 * long-running operations like polling and downloads.
 */

import { createCaveCanceledError } from './errors';

/**
 * Creates a function that throws a canceled error if the shouldAbort signal is true.
 *
 * Used within polling and download loops to interrupt operations when
 * the user cancels or a deadline is exceeded.
 *
 * @param {function} [shouldAbort] - Function that returns true if operation should abort
 * @returns {function} A function that throws CaveCanceledError if shouldAbort() is true
 */
export const createThrowIfAborted = shouldAbort => () => {
  if (shouldAbort?.() === true) {
    throw createCaveCanceledError();
  }
};
